
import { ReservationItemModule } from '@/store/modules/reservationItem';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'ReserveDiscount',
  components: {
  },
})

export default class extends Vue {
  get discountPolicies() {
    return ReservationItemModule.form.discountPolicies;
  }

  private deleteInfo(index: number) {
    this.discountPolicies.splice(index, 1);
  }

  private addInfo() {
    const defaultDiscount: any = {
      info: '',
      description: '',
      rate: '',
    };
    this.discountPolicies.push(defaultDiscount);
  }
}
